import React from 'react';
import Fragment from 'react-dot-fragment';
import BannerLayout from "../../../layouts/banner";

import Image from '../../../../../containers/assets/pf28.png';

const MarketShareStep13 = ({ previousShownErrors }) => (
  <BannerLayout
    section="FEEDBACK"
    subSection="MARKET SHARE"
    previousShownErrors={previousShownErrors}
    alertText="Demand Issue : Your sales channel choice might be sub-optimal."
    subTitle="Direct vs. Indirect Channels"
    paragraph2={(
      <Fragment>
        In this exercise, your team had to decide between using direct or indirect sales
        channels to sell your products to customers.
      </Fragment>
    )}
    visual={(
      <img src={Image} alt="preview" />
    )}
    visualProps={{
      noBorder: true,
      noBackground: true,
    }}
  />
);

export default MarketShareStep13;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/feedback/market-share/step13.js